import React, { memo } from "react";
import { useSelector } from "react-redux";
import { Row, Col } from "reactstrap";

const GridHeader = () => {
  const isModalPage = useSelector((state) => state.Layout.isModalPage);

  if (isModalPage) return null;

  return (
    <Row>
      <Col>
        <h5 className="text-color-azul1 font-size-24 fw-semibold mb-4">
          Desativar Categoria
        </h5>
      </Col>
    </Row>
  );
};

export default memo(GridHeader);